import { _ as _sfc_main } from "./VaButtonGroup.vue_vue_type_script_lang-3ce8af8b.mjs";
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createVNode, withCtx, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaButtonGroup_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_config = resolveComponent("va-config");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["va-button-group", _ctx.computedClass])
  }, [
    createVNode(_component_va_config, { components: _ctx.buttonConfig }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["components"])
  ], 2);
}
const _VaButtonGroup = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaButtonGroup as _
};

import '../../../VaButtonGroup.css';
//# sourceMappingURL=VaButtonGroup-ef58c025.mjs.map
